module.exports = __webpack_public_path__ + "static/img/money-packet.21dae12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/money-packet.png
// module id = FXKx
// module chunks = 216